import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {FormComponent} from '../form/form.component';

@Component({
	selector: 'app-input-radio',
	templateUrl: './input-radio.component.html',
	styleUrls: ['./input-radio.component.scss']
})
export class InputRadioComponent implements OnInit {
	@Input()
	name: string;
	@Input()
	label: string;
	@Input()
	options: string[];
	@Input()
	ngModel: string;
	@Output()
	ngModelChange = new EventEmitter<string>();

	constructor(public form: FormComponent) { }

	ngOnInit(): void {
	}
}
